import React from 'react'
import type { ComponentConfig } from '@puckeditor/core'
import { Section } from '../../components/Section'
import { WithLayout, withLayout } from '../../components/Layout'
import { RichtextField } from '../../fields/RichtextField'
import {
  ShadowProps,
  shadowStyleField,
  applyShadowStyle,
} from '../../fields/StyleFields'
import * as styles from './styles.module.scss'

export type RichtextProps = WithLayout<{
  content?: string
  shadow?: ShadowProps
}>

const RichtextInternal: ComponentConfig<RichtextProps> = {
  label: 'Rich Text',
  fields: {
    content: {
      type: 'custom',
      label: 'Content',
      render: ({ value, onChange, id }) => (
        <RichtextField
          field={{ type: 'custom', label: 'Content' }}
          value={value as string | undefined}
          onChange={onChange}
          id={id}
        />
      ),
    },
    shadow: shadowStyleField,
  },
  defaultProps: {
    content: '<p>Rich text</p>',
  },
  render: ({ content, shadow }) => (
    // paddingInline="0" removes the Section's built-in 16/24px side padding
    // (same as Grid/Flex) so the Layout padding field fully controls spacing.
    <Section paddingInline="0">
      <div
        className={styles.richtext}
        style={applyShadowStyle(shadow)}
        dangerouslySetInnerHTML={{ __html: content || '' }}
      />
    </Section>
  ),
}

export const Richtext = withLayout(RichtextInternal)
